/* Solartisch ST-450 – 3D-Bühne. Netze aus der Fusion-Baugruppe, Lage der Bauteile nach CAD-Maßen. */
(function () {
  var canvas = document.getElementById('st3d');
  var stage = document.querySelector('.st-stage');
  if (!canvas || !stage) return;
  function fail() { stage.classList.add('no-webgl'); }
  if (!window.THREE || !window.ST_MODEL) { fail(); return; }
  var T = window.THREE, M = window.ST_MODEL;

  var renderer;
  try { renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true }); }
  catch (e) { fail(); return; }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.toneMapping = T.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.2;

  var scene = new T.Scene();
  var camera = new T.PerspectiveCamera(30, 1, 1, 5000);

  // ---- Umgebung für Spiegelungen im Glas (neutrale Studio-Softboxen)
  (function () {
    var env = new T.Scene();
    var g = new T.SphereGeometry(500, 32, 16);
    var cols = [], pos = g.attributes.position;
    for (var i = 0; i < pos.count; i++) {
      var y = pos.getY(i) / 500, c = new T.Color();
      var shade = 0.055 + 0.09 * Math.max(0, y); c.setRGB(shade, shade, shade);
      cols.push(c.r, c.g, c.b);
    }
    g.setAttribute('color', new T.Float32BufferAttribute(cols, 3));
    env.add(new T.Mesh(g, new T.MeshBasicMaterial({ vertexColors: true, side: T.BackSide })));
    function box(w, h, x, y, z, k) {
      var m = new T.Mesh(new T.PlaneGeometry(w, h), new T.MeshBasicMaterial({ color: new T.Color(k[0], k[1], k[2]), side: T.DoubleSide }));
      m.position.set(x, y, z); m.lookAt(0, 0, 0); env.add(m);
    }
    box(250, 250, -150, 160, -290, [4, 4, 4]);
    box(220, 80, -300, 160, 200, [0.15, 0.15, 0.15]);
    box(400, 30, 0, 420, 0, [0.3, 0.3, 0.3]);
    box(600, 600, 0, -360, 0, [0.08, 0.08, 0.08]);
    box(300, 90, 320, -60, 120, [0.12, 0.12, 0.12]);
    var pm = new T.PMREMGenerator(renderer);
    scene.environment = pm.fromScene(env, 0.03).texture;
  })();

  // ---- Licht: Hauptlicht oben rechts, neutrales Streiflicht
  scene.add(new T.HemisphereLight(0xffffff, 0x292929, 0.55));
  var key = new T.DirectionalLight(0xffffff, 1.3); key.position.set(200, 280, -160); scene.add(key);
  var rim = new T.DirectionalLight(0xeeeeee, 1.0); rim.position.set(-260, 90, 220);
  var rim2 = new T.DirectionalLight(0xeeeeee, 0.5); rim2.position.set(260, -40, 200); scene.add(rim2);
  var under = new T.DirectionalLight(0xeeeeee, 0.9); under.position.set(80, -300, 60); scene.add(under); scene.add(rim);

  // ---- Geometrien aus dem Fusion-Export
  function b64(s, Ctor) {
    var bin = atob(s), u = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
    return new Ctor(u.buffer);
  }
  function geo(part) {
    var d = M[part], g = new T.BufferGeometry();
    var p = b64(d.p, Float32Array);
    g.setAttribute('position', new T.BufferAttribute(p, 3));
    g.setAttribute('normal', new T.BufferAttribute(b64(d.n, Float32Array), 3));
    g.setIndex(new T.BufferAttribute(b64(d.i, (p.length / 3) < 65536 ? Uint16Array : Uint32Array), 1));
    return g;
  }
  // Rahmen und Beine: tiefschwarz, seidenmatt
  var blackMat = new T.MeshStandardMaterial({ color: 0x050505, metalness: 0.25, roughness: 0.5, side: T.DoubleSide });
  blackMat.envMapIntensity = 0.18;
  var frameMat = new T.MeshStandardMaterial({ color: 0x060606, metalness: 0.3, roughness: 0.42, side: T.DoubleSide });
  frameMat.envMapIntensity = 0.22;
  // Winkelprofile: blankes Aluminium, Schrauben und Muttern: verzinkter Stahl
  var aluMat = new T.MeshStandardMaterial({ color: 0xe6e8eb, metalness: 0.72, roughness: 0.38, side: T.DoubleSide });
  aluMat.envMapIntensity = 2.4;
  var steelMat = new T.MeshStandardMaterial({ color: 0xc4c8cc, metalness: 1.0, roughness: 0.22, side: T.DoubleSide });
  steelMat.envMapIntensity = 2.2;
  var plastic = new T.MeshStandardMaterial({ color: 0x141312, metalness: 0.0, roughness: 0.7, side: T.DoubleSide });

  // Eine einzige UV-Fläche: feine Leiterbahnen ohne Kachelung, Zellfugen oder Unterbrechungen.
  function surfaceTexture() {
    var c = document.createElement('canvas'); c.width = 1536; c.height = 2400;
    var x = c.getContext('2d'), w = c.width, h = c.height;
    x.fillStyle = '#141414'; x.fillRect(0, 0, w, h);
    // Keine aufgemalte Spiegelung: Glanz entsteht ausschließlich aus Blickwinkel und Licht.
    x.lineWidth = 1.35; x.strokeStyle = 'rgba(250,250,247,0.36)'; x.beginPath();
    for (var i = 1; i < 96; i++) { var lx = i * w / 96; x.moveTo(lx, 0); x.lineTo(lx, h); }
    x.stroke();
    var texture = new T.CanvasTexture(c); texture.encoding = T.sRGBEncoding;
    texture.wrapS = texture.wrapT = T.ClampToEdgeWrapping;
    texture.minFilter = T.LinearMipmapLinearFilter; texture.magFilter = T.LinearFilter;
    texture.anisotropy = Math.min(16, renderer.capabilities.getMaxAnisotropy());
    return texture;
  }
  var glass = new T.MeshPhysicalMaterial({ map: surfaceTexture(), color: 0xffffff, metalness: 0, roughness: 0.18, clearcoat: 0.4, clearcoatRoughness: 0.10, reflectivity: 0.35, envMapIntensity: 0.22, opacity: 0.88, transparent: true, depthWrite: false, side: T.DoubleSide });

  var table = new T.Group();
  // Tischplatte: Rahmen 1135 × 1761 × 30, Oberseite y = 3 cm
  // Der CAD-Export enthält zwei massive Deckflächen innerhalb des Rahmens.
  // Sie würden die transparente Glasfläche von unten vollständig verdecken.
  var plateG = geo('plate'), plateP = plateG.attributes.position, plateI = plateG.index.array, frameIndices = [];
  for (var fi = 0; fi < plateI.length; fi += 3) {
    var ia = plateI[fi], ib = plateI[fi + 1], ic = plateI[fi + 2];
    var ax = plateP.getX(ia), ay = plateP.getY(ia), az = plateP.getZ(ia);
    var bx = plateP.getX(ib), by = plateP.getY(ib), bz = plateP.getZ(ib);
    var cx = plateP.getX(ic), cy = plateP.getY(ic), cz = plateP.getZ(ic);
    var horizontal = Math.abs(ay - by) < 0.001 && Math.abs(ay - cy) < 0.001;
    var areaXZ = Math.abs((bx - ax) * (cz - az) - (bz - az) * (cx - ax)) / 2;
    if (horizontal && areaXZ > 1000) continue;
    frameIndices.push(ia, ib, ic);
  }
  plateG.setIndex(frameIndices);
  table.add(new T.Mesh(plateG, frameMat));
  var top = new T.Mesh(new T.PlaneGeometry(111.7, 174.3), glass);
  top.rotation.x = -Math.PI / 2; top.position.set(56.75, 2.84, -88.05); table.add(top);
  top.renderOrder = 2;

  var LEGX = [6.25, 107.25], LEGZ = [-24.35, -151.75];   // Mitte 62,5 mm vom langen, 243,5 mm vom kurzen Rand
  var legG = geo('leg'), connG = geo('conn'), barG = geo('lbar'), m8G = geo('m8'), nutG = geo('nut'), m10G = geo('m10');
  connG.translate(-7.5, -1, 5);
  function put(g, mat, x, y, z, rx, ry) { var m = new T.Mesh(g, mat); m.position.set(x, y, z); m.rotation.set(rx || 0, ry || 0, 0); table.add(m); }
  LEGX.forEach(function (lx) {
    var outward = lx < 50 ? -1 : 1;                         // Richtung zum langen Rand
    LEGZ.forEach(function (lz) {
      put(legG, blackMat, lx, -70.1, lz);
      put(connG, plastic, lx, 1.2, lz, 0, outward * Math.PI / 2);
      // M10 × 35 als Gewindebolzen für das Bein, Kopf in der Tasche des Verbindungsstücks
      put(m10G, steelMat, lx, 1.2, lz, -Math.PI / 2);
      // 4 × M8 × 25 ISO 7380-2 von unten (Lippe bzw. Winkelprofil), oben DIN 985
      [[4.1, 0], [-3.0, 0.2]].forEach(function (h) {
        [6, -6].forEach(function (dz) {
          var hx = lx + outward * h[0], hz = lz + dz;
          put(m8G, steelMat, hx, h[1], hz, Math.PI / 2);
          put(nutG, steelMat, hx, 1.0, hz, -Math.PI / 2);
        });
      });
    });
  });
  LEGZ.forEach(function (cz) {
    put(barG, aluMat, 112.25, 0.2, cz + 7.8, 0, Math.PI / 2);
    put(barG, aluMat, 1.25, 0.2, cz - 7.8, 0, -Math.PI / 2);
  });
  table.position.set(-56.75, 0, 88.05);
  scene.add(table);

  // Kontaktschatten am Boden
  (function () {
    var c = document.createElement('canvas'); c.width = c.height = 256;
    var x = c.getContext('2d'), g = x.createRadialGradient(128, 128, 10, 128, 128, 128);
    g.addColorStop(0, 'rgba(0,0,0,0.55)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = g; x.fillRect(0, 0, 256, 256);
    var m = new T.Mesh(new T.PlaneGeometry(200, 290), new T.MeshBasicMaterial({ map: new T.CanvasTexture(c), transparent: true, depthWrite: false }));
    m.rotation.x = -Math.PI / 2; m.position.y = -70.2; scene.add(m);
  })();

  // Eigenständige Kamerafahrt nach der klar abgetrennten Produktüberschrift.
  var KEYS = [
    { az: 44, el: 35, d: 430, ty: -28, sx: 0.16, sy: 0, fov: 30 },
    { az: 12, el: 72, d: 360, ty: -10, sx: -0.16, sy: 0, fov: 30 },
    { az: 145, el: -22, d: 350, ty: -14, sx: 0.16, sy: 0, fov: 30 },
    { az: 88, el: 10, d: 390, ty: -30, sx: -0.16, sy: 0, fov: 30 }
  ];
  var steps = Array.prototype.slice.call(document.querySelectorAll('.st-step'));
  var stageVisible = true;
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) { stageVisible = entries[0].isIntersecting; }).observe(stage);
  }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W = 0, H = 0, narrow = false, centers = [];
  var scrollNow = window.scrollY, visualY = scrollNow;
  function clamp(t) { return Math.min(1, Math.max(0, t)); }
  function ease(t) { t = clamp(t); return t * t * (3 - 2 * t); }
  function mix(a, b, t) { var o = {}; for (var k in b) o[k] = a[k] + (b[k] - a[k]) * t; return o; }
  function resize() {
    var r = canvas.getBoundingClientRect();
    W = Math.max(1, r.width); H = Math.max(1, r.height); narrow = W <= 760;
    renderer.setSize(W, H, false);
    camera.aspect = W / H;
    centers = steps.map(function (step) { var b = step.getBoundingClientRect(); return b.top + window.scrollY + b.height / 2; });
  }
  function progress(y) {
    var mid = y + H / 2;
    for (var i = 1; i < centers.length; i++) {
      if (mid < centers[i]) return Math.max(0, i - 1 + clamp((mid - centers[i - 1]) / (centers[i] - centers[i - 1])));
    }
    return Math.max(0, Math.min(KEYS.length - 1, centers.length - 1));
  }
  // Verhindert bei großen Ansichten und schmalen Displays abgeschnittene Tischbeine.
  function fittedDistance(o) {
    var az = o.az * Math.PI / 180, el = o.el * Math.PI / 180;
    var a = Math.sin(az), b = Math.cos(az), c = Math.sin(el), e = Math.cos(el);
    var focal = H / (2 * Math.tan(o.fov * Math.PI / 360));
    var roomX = W * (0.46 - Math.abs(o.sx)), roomY = H * (0.44 - Math.abs(o.sy)), distance = o.d;
    [-56.75, 56.75].forEach(function (x) { [-70.1, 3].forEach(function (yy) { [-88.05, 88.05].forEach(function (z) {
      var y = yy - o.ty, right = b * x - a * z, up = -a * c * x + e * y - b * c * z, depth = a * e * x + c * y + b * e * z;
      distance = Math.max(distance, depth + Math.abs(right) * focal / roomX, depth + Math.abs(up) * focal / roomY);
    }); }); });
    return distance;
  }
  function target(p) {
    p = Math.max(0, Math.min(KEYS.length - 1, p));
    var i = Math.floor(p), o = mix(KEYS[i], KEYS[Math.min(i + 1, KEYS.length - 1)], ease(p - i));
    if (narrow) { o.sx = 0; o.sy = -0.20 + 0.10 * clamp((o.el - 35) / 37); o.fov = 38; }
    o.d = fittedDistance(o);
    return o;
  }
  var previous = performance.now();
  function frame(now) {
    var dt = Math.min(64, Math.max(0, now - previous)); previous = now;
    visualY += (scrollNow - visualY) * (reduce ? 1 : 1 - Math.exp(-dt / 100));
    var goal = target(window.__stP != null ? window.__stP : progress(visualY));
    var az = goal.az * Math.PI / 180, el = goal.el * Math.PI / 180;
    camera.position.set(Math.sin(az) * Math.cos(el) * goal.d, goal.ty + Math.sin(el) * goal.d, Math.cos(az) * Math.cos(el) * goal.d);
    camera.lookAt(0, goal.ty, 0);
    camera.fov = goal.fov;
    camera.setViewOffset(W, H, -goal.sx * W, -goal.sy * H, W, H);
    if (stageVisible && !document.hidden) renderer.render(scene, camera);
    requestAnimationFrame(frame);
  }
  window.addEventListener('scroll', function () { scrollNow = window.scrollY; }, { passive: true });
  window.addEventListener('resize', resize);
  window.addEventListener('load', resize);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(resize);
  resize();
  requestAnimationFrame(frame);
  stage.classList.add('webgl-ready');
})();
